/* unplugin-vue-components disabled */import script from "./Issue.vue?vue&type=script&lang=ts&setup=true"
export * from "./Issue.vue?vue&type=script&lang=ts&setup=true"

import "./Issue.vue?vue&type=style&index=0&id=1b7b382a&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b7b382a"]])

export default __exports__